export default __webpack_public_path__ + "static/2-7a96e351181e02d431829c4352166155.jpeg";